module.exports = __webpack_public_path__ + "img/summary_4.7c91e552.png";